import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"pea"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M10.2684 19.9998C15.7912 19.9998 20.2684 15.5227 20.2684 9.99981C20.2684 8.64157 19.9976 7.34657 19.507 6.16586L13.499 9.63463L8.30365 12.6341L2.33057 16.0827C4.15844 18.4644 7.03409 19.9998 10.2684 19.9998Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M22.1607 4.63379L7.89483 12.8702C5.23529 11.9185 3.06019 9.94851 1.83936 7.42993L22.1607 4.63379Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M22.1607 4.63379L7.89483 12.8702C5.23529 11.9185 3.06019 9.94851 1.83936 7.42993L22.1607 4.63379Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19.507 6.16667L22.1607 4.63379L19.507 6.16586L13.499 9.63463M8.30365 12.6341L13.499 9.63463M8.30365 12.6341L9.80365 15.2322M8.30365 12.6341L2.33057 16.0827C4.15844 18.4644 7.0341 19.9998 10.2684 19.9998C15.7912 19.9998 20.2684 15.5227 20.2684 9.99982C20.2684 8.69282 20.0176 7.44439 19.5616 6.3M13.499 9.63463L14.999 12.2327","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Pea = Vue.extend<IconProps>({
  name: 'PeaIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'pea',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Pea;
